import { getItem, setItem } from "@swa-ui/persistence";

const SWAV_BOOKING_DATA_KEY = "swavBookingData";
const TTL = 30;

export const getPersistedVacationsBookingData = () => {
  const results = getItem(SWAV_BOOKING_DATA_KEY, {});

  return results?.value;
};

export const setPersistedVacationsBookingData = (swavBookingData) => {
  setItem(SWAV_BOOKING_DATA_KEY, swavBookingData, {
    timeToLiveInMinutes: TTL,
  });
};
